import React, {useRef, useState, useEffect, useMemo} from 'react';
import Popup from 'reactjs-popup';
import {CgMathPlus} from  'react-icons/cg';
import 'reactjs-popup/dist/index.css';
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import useFetch from '../../shared/hooks/useFetch';
import appSettings from "../../appSettings.json";

import './TicketList.css';
import TicketTable from '../../components/TicketTable/TicketTable.js';
import NewTicket from '../../components/NewTicket/NewTicket.js'

const StyledPopup = styled(Popup)`
  &-content {
    width: 1650px !important;
    max-width: 2670;
    overflow-y: auto;
    height: 95vh;
  }
`;

const TicketList = (props) => {
    const { user, usersSAT, setTicketsStateSummary, formikValues, setFormikValues, resetTicketFilters } = props
    const ref = useRef();
    const closeTooltip = () => ref.current.close();

    /* Llamada API metodo getTickets */
    const getTickets = `${appSettings.BASE_URL.default}/ticket/get`;

    const [renderView, setRenderView] = useState(false);
    const { serviceResponse, loading } = useFetch(
        getTickets,
        { 'Content-Type': 'application/json', Authorization: 'Bearer ' + user.token },
        'GET',
        '',
        renderView
    );

    const [dataTicketsAux, setDataTicketsAux] = useState([]);

    useEffect(() => {
        if (!loading) {
            setDataTicketsAux(Array.isArray(serviceResponse?.data) ? serviceResponse.data : []);
        }
    }, [loading, serviceResponse]);

    const installations = useMemo(
        () => [...new Set(dataTicketsAux.map(t => t.instalacionUsuario))],
        [dataTicketsAux]
    );
    return (
        <div className = 'container-fluid' style={{minHeight: 'calc(100vh - 155px)'}}>
            <div className = 'row' style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <div className = 'col-3 d-inline-flex flex-row'>
                    <h5 style = {{marginTop: "5px", fontWeight: "500"}}>Gestión de Tickets</h5>
                </div>
                <div className = 'col d-inline-flex justify-content-center'></div>
                <div className = 'col-4 d-inline-flex flex-row-reverse'>
                    <div>
                        <div className = 'd-inline-flex flex-row' style = {{marginRight: "10px"}}>
                            <StyledPopup
                                ref={ref}
                                trigger = {
                                    <button type = "button" className = 'btn btn-outline-success'><CgMathPlus/></button>
                                }
                                modal
                            >
                                <div>
                                    {<NewTicket user = {user} close = {closeTooltip} usersSAT = {usersSAT} renderView = {renderView} setRenderView = {setRenderView} installations = {installations} dataTicketsAux = {dataTicketsAux}/>}
                                </div>
                            </StyledPopup>
                        </div>
                    </div>
                </div>
            </div>
            <hr size = "4px"/>
            <div style = {{margin: "10px 10px"}}>
                <TicketTable user = {user} setTicketsStateSummary = {setTicketsStateSummary} formikValues = {formikValues} setFormikValues = {setFormikValues} dataTicketsAux = {dataTicketsAux} resetTicketFilters = {resetTicketFilters} loadingTickets = {loading} successTickets = {serviceResponse?.success} messageTickets = {serviceResponse?.message}/>
            </div>
        </div>  
    );
}

export default TicketList;
